export const PAGE_SIZE = parseInt(import.meta.env.VITE_PAGE_SIZE || '200', 10);

export interface SliceInfo {
  startIndex: number;
  stopIndex: number;
}
